import React from "react"
import { useSnackbar } from "notistack"
import { RoboCidades } from "../../../services/apiRobo"
import { erroMsg } from "../components/comum"

/** Cidades (porte da rail 🌎): panorama de leads por cidade + grupos/gestores mapeados. */
export function Cidades() {
    const { enqueueSnackbar } = useSnackbar()
    const [panorama, setPanorama] = React.useState<any[]>([])
    const [mapeadas, setMapeadas] = React.useState<any[]>([])
    const [carregando, setCarregando] = React.useState(false)

    const carregar = React.useCallback(async () => {
        setCarregando(true)
        try {
            const [p, m] = await Promise.all([
                RoboCidades.panorama().catch(() => []),
                RoboCidades.listar().catch(() => []),
            ])
            setPanorama(Array.isArray(p) ? p : p?.items || [])
            setMapeadas(Array.isArray(m) ? m : m?.items || [])
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        } finally {
            setCarregando(false)
        }
    }, [enqueueSnackbar])

    React.useEffect(() => {
        carregar()
    }, [carregar])

    return (
        <section className="panel active" style={{ display: "block" }}>
            <div className="panel-actions">
                <h3 style={{ margin: 0 }}>🌎 Cidades</h3>
                <button className="ghost" onClick={carregar}>
                    ↻ Atualizar
                </button>
            </div>
            {carregando && <div className="muted small" style={{ padding: 12 }}>Carregando…</div>}

            <div style={{ padding: "0 12px 12px" }}>
                <h3 style={{ fontSize: 14 }}>Panorama (leads por cidade)</h3>
                <table style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>UF</th>
                            <th>Cidade</th>
                            <th style={{ textAlign: "right" }}>Leads</th>
                            <th style={{ textAlign: "right" }}>No grupo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {panorama.map((c, i) => (
                            <tr key={i}>
                                <td>{c.uf || "—"}</td>
                                <td>{c.cidade || "—"}</td>
                                <td style={{ textAlign: "right" }}>{c.total ?? c.leads ?? c.count ?? "—"}</td>
                                <td style={{ textAlign: "right" }}>{c.noGrupo ?? c.emGrupo ?? "—"}</td>
                            </tr>
                        ))}
                        {!carregando && panorama.length === 0 && (
                            <tr>
                                <td colSpan={4}>
                                    <span className="muted small">Sem leads com cidade.</span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <h3 style={{ fontSize: 14, marginTop: 16 }}>Cidades mapeadas (grupo/gestor)</h3>
                {mapeadas.length === 0 && <div className="muted small">Nenhuma cidade mapeada.</div>}
                <ul className="list" style={{ listStyle: "none", margin: 0, padding: 0 }}>
                    {mapeadas.map((c: any) => (
                        <li
                            key={c.id}
                            style={{
                                background: "var(--panel)",
                                border: "1px solid var(--border)",
                                borderRadius: 6,
                                padding: 10,
                                marginBottom: 6,
                            }}
                        >
                            <strong>
                                {c.cidade}
                                {c.uf ? "/" + c.uf : ""}
                            </strong>
                            <div className="muted small">
                                {c.grupoNome ? "Grupo: " + c.grupoNome : "sem grupo"}
                                {c.gestorNome ? " · Gestor: " + c.gestorNome : ""}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default Cidades
